import {
  patientTypeDictionary,
  type IPatientType,
} from "@medoma/models/patients";
import { useFormContext, type FieldValues } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import type { TemplatePatientTypePickerFields } from "@/pages/template-manager/TemplateForm/templateFormSchema";

export const TemplatePatientType = ({
  availablePatientTypes,
}: {
  availablePatientTypes: IPatientType[];
}) => {
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();
  const { t } = useLingui();
  const fieldName =
    useFieldPathWithPrefix<TemplatePatientTypePickerFields>("patientType");
  const errorMessage = useFieldErrorWithPrefix<TemplatePatientTypePickerFields>(
    errors,
    "patientType",
  );

  return (
    <RadioButtons
      legend={t`Typ av patient`}
      errorMessage={errorMessage}
      orientation="horizontal"
    >
      {availablePatientTypes.length < 1 ? (
        <ErrorMessage message={t`Inga patienttyper hittades.`} />
      ) : (
        <>
          {availablePatientTypes.map((type) => (
            <RadioButton
              key={type}
              {...register(fieldName, {
                required: {
                  value: true,
                  message: t`Välj vilken typ av patient mallen ska användas för`,
                },
              })}
              label={{ text: t(patientTypeDictionary[type]) }}
              value={type}
              visualStyle="framed"
            />
          ))}
        </>
      )}
    </RadioButtons>
  );
};
